import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../style/TableActionItems.css';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons/faPlayCircle';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const CalendarSecondRoundButton = (props) => {
  function getCalendarIcon() {
    return (
      <>
        {props.hasCalendarSecondRound ? (
          <FontAwesomeIcon icon={faCheck} />
        ) : (
          <>
            <OverlayTrigger
              key="trigger"
              placement="left"
              overlay={
                <Tooltip id={`tooltip-trigger`}>
                  Genereeri kalendi II voor
                </Tooltip>
              }
            >
              <FontAwesomeIcon
                className="action"
                icon={faPlayCircle}
                onClick={props.generateAction}
              />
            </OverlayTrigger>
          </>
        )}
      </>
    );
  }

  return <div>{props.numberOfTeams > 9 ? getCalendarIcon() : ''}</div>;
};
